import ServicePage from "@/components/ServicePage";
export default function NailLounge() {
  return <ServicePage slug="nails" />;
}
